function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "vertical-align-middle_svg__a",
  d: "M13.352 18.146l4.308 4.308a.5.5 0 01-.354.854L14 23.307V28.5a1 1 0 01-2 0v-5.193H8.691a.5.5 0 01-.354-.853l4.308-4.308a.5.5 0 01.707 0zM24.184 14c.727 0 1.316.448 1.316 1s-.59 1-1.316 1H1.816C1.089 16 .5 15.552.5 15s.59-1 1.316-1h22.368zM13 .5a1 1 0 011 1v5.19h3.306a.5.5 0 01.41.788l-.056.066-4.308 4.307a.5.5 0 01-.638.058l-.069-.058-4.308-4.307a.5.5 0 01.268-.847l.086-.007H12V1.5a1 1 0 011-1z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "vertical-align-middle_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#vertical-align-middle_svg__a"
})), React.createElement("use", {
  fill: "#000",
  fillRule: "nonzero",
  xlinkHref: "#vertical-align-middle_svg__a"
}), React.createElement("g", {
  fill: "#000",
  mask: "url(#vertical-align-middle_svg__b)"
}, React.createElement("path", {
  d: "M-160-36.09h340v100h-340z"
})));

var SvgVerticalAlignMiddle = function SvgVerticalAlignMiddle(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 26 30"
  }, props), _ref, _ref2);
};

export default SvgVerticalAlignMiddle;